import {
  colors,
  ApLoaderDefault,
  ApButtonTab,
} from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: calc(100% - 48px);
  flex-direction: column;
`;

export const EmptyPlaceholder = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  &::after {
    content: 'No reports are published.';
  }
`;

export const SecondaryNavigation = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 32px;
  border-bottom: 1px solid ${colors.grey3};
  background-color: ${colors.white};
`;

export const Overlay = styled(ApLoaderDefault)`
  position: absolute;
  background-color: ${colors.white};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
`;

interface IReportWrapper {
  pageHeight?: number | null;
}

export const ReportWrapper = styled.div<IReportWrapper>`
  min-height: ${({ pageHeight }) =>
    pageHeight ? `${pageHeight}px` : 'calc(100% - 4px)'};
  height: calc(100% - 152px);
`;

export const ScrollableContent = styled.div`
  overflow: auto;
  height: 100%;
  position: relative;
`;

export const Loading = styled(ApLoaderDefault)`
  display: flex;
  flex: 4;
  flex-direction: column;
  padding: 16px 20px;
  background-color: ${colors.grey1};
`;

export const PageLoading = styled(ApLoaderDefault)`
  display: flex;
  flex: 4;
  flex-direction: column;
  padding: 16px 20px;
  height: calc(100% - 48px);
`;

export const ButtonTab = styled(ApButtonTab)`
  > div {
    max-width: 100%;
  }
`;
